// src/config/wsBotConnectionConfig.js (NEW FILE)

export const WS_BOT_CONNECTION_TYPES = {
  // Client -> Server
  CONNECT_SERVER: 'BOT_CONNECT_SERVER',
  DISCONNECT_SERVER: 'BOT_DISCONNECT_SERVER',
  DEPLOY_BOT: 'BOT_DEPLOY',
  STOP_DEPLOYMENT: 'BOT_STOP_DEPLOYMENT',
  GET_STATE: 'BOT_GET_STATE',
  GET_HISTORY: 'BOT_GET_HISTORY', // New

  // Server -> Client (via user-specific queue)
  CONNECTION_STATUS: 'BOT_CONNECTION_STATUS',
  DEPLOYMENT_STARTED: 'BOT_DEPLOYMENT_STARTED',
  DEPLOYMENT_PROGRESS: 'BOT_DEPLOYMENT_PROGRESS',
  DEPLOYMENT_COMPLETED: 'BOT_DEPLOYMENT_COMPLETED',
  CONSOLE_LINE: 'BOT_CONSOLE_LINE',
  CURRENT_STATE: 'BOT_CURRENT_STATE',
  ERROR: 'BOT_ERROR',
  HISTORY_LIST: 'BOT_HISTORY_LIST', // New
  HISTORY_ERROR: 'BOT_HISTORY_ERROR', // New
};

export const WS_BOT_CONNECTION_TOPICS = {
  USER_QUEUE_BASE: '/user/queue/bots',
  STATUS: '/status',
  PROGRESS: '/progress',
  ERROR: '/error',
  USER_HISTORY: '/history', // New user queue topic

  APP_ENDPOINT: '/bots',
  APP_GET_HISTORY: '/get-history', // New app endpoint path
};
// Helper function (add if needed, or use base + topic directly)
export const getBotAppEndpoint = (action) => `${WS_BOT_CONNECTION_TOPICS.APP_ENDPOINT}${action}`;
export const getBotUserQueueTopic = (subTopic) => `${WS_BOT_CONNECTION_TOPICS.USER_QUEUE_BASE}${subTopic}`;